<ng-template #itemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand"
             let-onCheckedChange="onCheckedChange">
  <div class="form-inline row-item">
    <i *ngIf="item.children" (click)="onCollapseExpand()" aria-hidden="true" class="fa"
       [class.fa-caret-right]="item.collapsed"
       [class.fa-caret-down]="!item.collapsed"></i>
    <div class="form-check">
      <input type="checkbox" class="form-check-input" [(ngModel)]="item.checked" (ngModelChange)="onChangeItem(item)"
             [disabled]="item.disabled"
             [indeterminate]="item.indeterminate" />
      <label class="form-check-label" (click)="item.checked = !item.checked; onChangeItem(item)">
        {{item.text}}
      </label>
    </div>
  </div>
</ng-template>
<!--             TODO: Move this code to controller to respond the buttons conditionally based on the actions. -->


<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>
<re-alert *ngIf="showMessage" type="success" (close)="showMessage = false">
  <strong *ngIf="userAction === 'CREATED'">New user {{user.firstName}} {{user.lastName}} has been created.</strong>
  <strong *ngIf="userAction === 'Deactivate'">User {{user.firstName}} {{user.lastName}} has been deactivated.</strong>
  <strong *ngIf="userAction === 'Suspend'">User {{user.firstName}} {{user.lastName}} has been suspended.</strong>
  <strong *ngIf="userAction === 'Unlock'">User {{user.firstName}} {{user.lastName}} has been unlocked.</strong>
  <strong *ngIf="userAction === 'Activate'">User {{user.firstName}} {{user.lastName}} has been activated.</strong>
  <strong *ngIf="userAction === 'Edit Profile'">Profile for {{user.firstName}} {{user.lastName}} has been updated.</strong>
  <strong *ngIf="userAction === 'Reset Password' && emailMessage">A reset password email has been sent to {{user.firstName}} {{user.lastName}}.</strong>
  <strong *ngIf="userAction === 'Reset Password' && !emailMessage">Temporary password generated. Communicate the temporary password to {{user.firstName}} {{user.lastName}}.</strong>
  <strong *ngIf="userAction === 'DeleteMFA'">Multifactor Authentication for the user {{user.firstName}} {{user.lastName}} has been disabled.</strong>
  <strong *ngIf="userAction === 'ActivateMFA'">Multifactor Authentication has been activated for {{user.firstName}} {{user.lastName}}.</strong>
  <strong *ngIf="userAction === 'AuthorizeMFA'">Multifactor Authentication has been activated for {{user.firstName}} {{user.lastName}}.</strong>
</re-alert>

<re-alert *ngIf="errorCount>0" type="danger">
  <span class="alert-message">Some errors occurred. Go to <a class="ml-2" [routerLink]="['/transaction-log']" [queryParams]="{search: user.ssoid}">Transaction Log</a> to view more details for the user.</span>
</re-alert>

<div class="alert alert-info" role="alert" *ngIf="isPhysicianNppaUser">
  <i class="alert-close" data-dismiss="alert" (click)="closeAlert()" aria-hidden="true" aria-label="Close"></i>
  <b>Matrixcare 360:</b> For Physician/NPPA users: eSignatures, EPCS, Discharge Orders using SureScripts and Provider Groups are managed in MatrixCare 360.
</div>

<div class="row" *ngIf="!profileLoading">
  <div class="col-12 mb-4">
    <h1 *ngIf="user">
      {{user.firstName}} {{user.lastName}} <img height="16" data-toggle="tooltip" data-placement="right" title='Federated User' style="margin-top:-3px" *ngIf="user.federatedIdentity" class='pl-2' src='assets/images/Federated User Icon.svg' />
    </h1>

    <dl class="dl-horizontal">
      <dt>Status: </dt>
      <dd>{{user.status }}</dd>
      <dt>Username: </dt>
      <dd>
        {{user.userName}}
        <a style="text-decoration: none;" [routerLink]="[]" *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin" (click)="updateUsername()">
          <span class="fa fa-pencil text-primary ml-1"></span> Edit
        </a>
      </dd>
      <dt>SSO ID: </dt>
      <dd>{{user.ssoid}} <a [routerLink]="[]" (click)="copySSOID()">Copy SSO ID</a></dd>
    </dl>
  </div>
</div>
<div class="row" *ngIf="!profileLoading">
  <div class="col-12">
    <div class="form-group">
      <button (click)="back()" class="btn btn-default mr-3">Back</button>
      <!--
      Section of buttons for Corporate (User Managemnet Access) and Location Management admins
      -->
      <ng-container *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">
          <button class="btn btn-primary" *ngIf="(user.status === 'Deactivated' || user.status === 'Suspended' || user.status === 'Staged')" (click)="activate(user.ssoid, user.status)">Activate</button>
          <button class="btn btn-primary" *ngIf="(user.status != 'Suspended' && user.status != 'Deactivated' && canLmaDeactivateOrSuspendUser)" (click)="open('Suspend')">Suspend</button>
          <button class="btn btn-danger" *ngIf="(user.status != 'Deactivated' && canLmaDeactivateOrSuspendUser)" (click)="open('Deactivate')">Deactivate</button>
          <button class="btn btn-primary" *ngIf="!user.federatedIdentity && azureADEnabled" (click)="convertToFederated()">Convert to Federated</button>
          <button class="btn btn-primary" *ngIf="user.federatedIdentity" (click)="convertToIDM()">Convert to IDM</button>
          <button class="btn btn-danger" *ngIf="(user.status === 'Deactivated')" (click)="open('Delete')">Delete</button>
      </ng-container>
      <!--
      Section of buttons for any customer admin.
      -->
      <ng-container *ngIf="!isSupportUser" class="buttonSpacing12px">
          <button class="btn btn-primary" *ngIf="user.status === 'Locked out'" (click)="unlock(user.ssoid)">Unlock</button>
          <button class="btn btn-primary"
                  *ngIf="(user.status != 'Suspended' && user.status != 'Deactivated' && user.status != 'Staged' && !user.federatedIdentity && !(user.status === 'Pending user action' && savedEmail === '') && ((user.status !== 'Pending user action') || (savedEmail !== '') || (user.email === savedEmail)))"
                  (click)="open('Reset Password')">{{user.status === 'Pending user action' ? 'Resend Password Email' : 'Reset Password'}}</button>
          <button class="btn btn-primary" *ngIf="(user.status === 'Active') && !user.federatedIdentity && !isUserLocationLimitedAdmin"
                  (click)="open('Enroll MFA')">{{user.factor?.smsFactorEnabled ? 'Reset Prescriber MFA' : 'Enroll Prescriber MFA'}}</button>
      </ng-container>
     </div>
  </div>
</div>


<div class="d-flex justify-content-start mb-3">
  <div *ngIf="user?.configName">
    Environment:<span class="ml-2">{{user.configName}}</span>
  </div>

  <div class="ml-auto">
    <a (click)="expandAll()" [routerLink]="[]">Expand All</a> | <a [routerLink]="[]" (click)="collapseAll()">Collapse All</a>
  </div>

</div>




<form id="updateUserForm" [formGroup]="updateUserForm">
  <re-collapsible-group header="Profile Details" [(isCollapsed)]="collapsed['profile']">
    <ng-container>
      <div *ngIf="profileLoading">
        <div class="spinner spinner-sm">
          <div class="lspinner"></div>
        </div>
        <div class="text-center">Profile details section is loading</div>
      </div>
      <div *ngIf="!profileLoading">
        <div class="row">
          <div class="col-12">
            <div class="form-group mb-4" *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin ">
              <button class="btn btn-default" *ngIf="!editProfile" (click)="editProfileClicked()" [disabled]="loadingUser">Edit</button>
              <button class="btn btn-success" *ngIf="editProfile" [disabled]="!updateUserForm.valid || !validFeratedLoginId()" (click)="updateUserProfile()">Save</button>
              <button class="btn btn-cancel" *ngIf="editProfile" (click)="resetProfileFlags()">Cancel</button>
            </div>
          </div>
        </div>

        <div class="row">


          <div class="col-12 col-sm-6 col-lg-4">
            <div class="form-group">
              <label for="prefix">Prefix</label>
              <span id="prefix" *ngIf="!canEditProfileAttribute" class="form-control-plaintext">{{user.prefix}}</span>
              <ng-select2 class="user-detail" *ngIf="canEditProfileAttribute" [data]="prefixData" width="100%"
                          [(ngModel)]="user.prefix" allowClear="true" placeholder="Not Selected"
                          formControlName="prefix"></ng-select2>
            </div>
          </div>


          <div class="col-12 col-sm-6 col-lg-4">
            <div class="form-group input-required">
              <label for="firstName">First Name</label>
              <!--[disabled]="user.federatedIdentity"-->
              <input id="firstName" [(ngModel)]="user.firstName" formControlName="firstName" value="{{user.firstName}}" type="text" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}">
              <small *ngIf="updateUserForm.controls['firstName'].hasError('required') && updateUserForm.controls['firstName'].touched" class="text-danger">Please enter your first name.</small>


            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-4">
            <div class="form-group">
              <label for="middleName">Middle Name</label>
              <input id="middleName" [(ngModel)]="user.middleName" formControlName="middleName" value="{{user.middleName}}" type="text" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}">
            </div>
          </div>

        </div>
        <div class="row">

          <div class="col-12 col-sm-6 col-lg-4">
            <div class="form-group input-required">
              <label for="lastName">Last Name</label>
              <input id="lastName" [(ngModel)]="user.lastName" formControlName="lastName" value="{{user.lastName}}" type="text" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}">
              <small *ngIf="updateUserForm.controls['lastName'].hasError('required') && updateUserForm.controls['lastName'].touched" class="text-danger">Please enter your last name.</small>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-4">
            <div class="form-group" [class.input-required]="updateUserForm.get('physicianNppaEnabled')?.value">
              <label for="title">Title</label>
              <input id="title" maxlength="10" [(ngModel)]="user.title" formControlName="title" value="{{user.title}}" type="text" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}">
              <small *ngIf="updateUserForm.controls['title'].hasError('required') && updateUserForm.controls['title'].touched" class="text-danger">
                Title is required for Physician NP/PA users.
              </small>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-4">
            <div class="form-group" [class.input-required]="updateUserForm.get('physicianNppaEnabled')?.value">
              <label for="email">Email</label>
              <input id="email" [(ngModel)]="user.email" formControlName="email"
                type="text" [readonly]="!canEditProfileAttribute"
                [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"/>
              <small *ngIf="updateUserForm.controls['email'].hasError('required') && updateUserForm.controls['email'].touched" class="text-danger">
                Email is required for Physician NP/PA users.
              </small>
              <small *ngIf="updateUserForm.controls['email'].hasError('email') && updateUserForm.controls['email'].touched" class="text-danger">
                Please enter a valid email.
              </small>
            </div>
          </div>

          <!-- I am not sure if SSO ID belongs to any of these sections. Can't be edited, can't be interacted with, and it's already displayed on top of page. -->
        </div>

        <div class="row">

          <div *ngIf="federationLoginIdEnabled && user.federatedIdentity" class="col-12 col-sm-6 col-lg-4">
            <div class="form-group  input-required">
              <label for="federatedLoginID">Federated Login Id</label>
              <div class="custom-checkbox custom-control-inline ml-5" *ngIf="editProfile">
                <input type="checkbox" formControlName="sameAsUsername" id="sameAsUsername" class="custom-control-input">
                <label class="custom-control-label" for="sameAsUsername">Same as Username</label>
              </div>


              <div class="input-group">
                <span id="federatedLoginID" class="form-control-plaintext" *ngIf="!editProfile">{{originalFederatedIdentityId}}</span>

                <input id="federatedLoginID" [(ngModel)]="federatedUserName" formControlName="federatedLoginID" value="{{federatedUserName}}" type="text" *ngIf="editProfile" class="form-control">

                <div class="input-group-append" *ngIf="editProfile">
                  <span *ngIf="usernameDomains?.length==1" class="input-group-text btn-cancel" style="height:40px" id="basic-addon1">&#64;{{selectedFederatedLoginIdDomain}}</span>

                  <div *ngIf="usernameDomains?.length>1" ngbDropdown class="d-inline-block">
                    <button [disabled]="updateUserForm.get('sameAsUsername').value" class="btn btn-cancel form-control" type="button" id="selectedFederatedLoginIdDomainDropdown" ngbDropdownToggle>&#64;{{selectedFederatedLoginIdDomain}}<span style="margin-right:10px">&nbsp;</span></button>
                    <div ngbDropdownMenu aria-labelledby="selectedFederatedLoginIdDomainDropdown">
                      <button type="button" class="dropdown-item" *ngFor="let option of usernameDomains" (click)="selectedFederatedLoginIdDomain=option">&#64;{{option}}</button>
                    </div>
                  </div>
                </div>

                <small *ngIf="updateUserForm.controls['federatedLoginID'].hasError('maxlength') && updateUserForm.controls['federatedLoginID'].touched"
                       class="text-danger">Max 100 characters for Federated Login ID.</small>


                <p *ngIf="updateUserForm.controls['federatedLoginID'].hasError('maxlength') && updateUserForm.controls['federatedLoginID'].touched" class="text-danger">Max 100 characters for Federated Login ID.</p>
              </div>
            </div>
          </div>


          <div class="col-sm-6 col-lg-3">
            <div class="form-group" [class.input-required]="updateUserForm.get('physicianNppaEnabled')?.value">
              <label for="primaryPhone">Primary Phone</label>
              <input id="primaryPhone" [(ngModel)]="user.primaryPhone" formControlName="primaryPhone"
                type="text" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"
                maxlength="10"/>
              <small *ngIf="updateUserForm.controls['primaryPhone'].hasError('required') && updateUserForm.controls['primaryPhone'].touched" class="text-danger">
                Primary Phone is required for Physician NP/PA users.
              </small>
              <small *ngIf="updateUserForm.controls['primaryPhone'].hasError('pattern') && updateUserForm.controls['primaryPhone'].touched" class="text-danger">
                Please enter a valid phone number.
              </small>
            </div>
          </div>

          <div class="col-sm-6 col-lg-1">
            <div class="form-group">
              <label for="ext">Ext</label>
              <input id="ext" formControlName="ext" maxlength="5" [(ngModel)]="user.ext"
                     type="text" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"/>
              <small *ngIf="updateUserForm.controls['ext'].hasError('pattern') && updateUserForm.controls['ext'].touched" class="text-danger">
                Only numeric values are allowed.
              </small>
            </div>
          </div>

          <div class="col-sm-6 col-lg-4">
            <div class="form-group">
              <label for="mobilePhone">Mobile Phone</label>
              <input id="mobilePhone" [(ngModel)]="user.mobilePhone" formControlName="mobilePhone" type="text" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}" maxlength="10">
              <small *ngIf="updateUserForm.controls['mobilePhone'].hasError('pattern') && updateUserForm.controls['mobilePhone'].touched" class="text-danger">Please enter a valid phone number</small>
            </div>
          </div>

          <div class="col-sm-6 col-lg-4" *ngIf="employeeIdEnabled">
            <div class="form-group">
              <label for="customerEmployeeId">Employee Id</label>
              <input id="customerEmployeeId" maxlength="50" [(ngModel)]="user.customerEmployeeId" formControlName="customerEmployeeId" type="text" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}">
            </div>
          </div>

          <div class="col-sm-6 col-lg-4" *ngIf="(isCustomerAdmin || isLocationAdmin) && !isPhysicianNppaUser">
            <div class="form-group">
              <label for="deactivationDate">Deactivation Date</label>
              <div class="has-feedback datepicker-control" [ngStyle]="{'pointer-events': !canEditProfileAttribute ? 'none' : 'auto'}">
                <input [minDate]="minDate" #dp="bsDatepicker" autocomplete="off" maxlength="10" bsDatepicker
                       [bsConfig]="{animate:true, containerClass:'theme-dark-blue'}"
                       [(ngModel)]="user.deactivationDate" type="text" class="form-control"
                       formControlName="deactivationDate"
                       [hidden]="!canEditProfileAttribute"
                       (input)="onDeactivationDateChange($event.target.value)">
                <span class="form-control-plaintext" *ngIf="!canEditProfileAttribute && originalDeactivationDate">{{ originalDeactivationDate }}</span>
                <a class="form-control-feedback" (click)="dp.toggle()" [attr.aria-expanded]="dp.isOpen" [hidden]="!canEditProfileAttribute"></a>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="showPhysicianNppaCheckbox && (isCustomerAdmin || isCorporateLimitedAdmin || isLocationAdmin || isUserLocationLimitedAdmin)" class="d-flex align-items-center">
          <div class="form-check">
            <input type="checkbox" id="physicianNppaCheckbox"
                   class="form-check-input" formControlName="physicianNppaEnabled"
                   [(ngModel)]="user.physicianNppaEnabled"
                   [attr.disabled]="!editProfile || user.physicianNppaEnabled || (!isCustomerAdmin && !isLocationAdmin) ? true : null"
                   (click)="onPhysicianNppaChange($event.target.checked)"/>
            <label for="physicianNppaCheckbox" class="form-check-label">Physician NP/PA User</label>
          </div>
        </div>
      </div>

      <form [formGroup]="updateUserForm">
        <!-- Other form fields -->
        <app-physician-nppa-user-child *ngIf="user.physicianNppaEnabled && (isCustomerAdmin || isCorporateLimitedAdmin || isLocationAdmin || isUserLocationLimitedAdmin)" [parentForm]="updateUserForm"
        [editProfile]="editProfile && (isCustomerAdmin || isLocationAdmin)"
        [canEditProfileAttribute]="canEditProfileAttribute && (isCustomerAdmin || isLocationAdmin)"
        [profileLoading]="profileLoading"
        [user]="user"
        ></app-physician-nppa-user-child>
      </form>

    </ng-container>
  </re-collapsible-group>

  <re-collapsible-group *ngIf="mfaEnabled && !user.federatedIdentity" header="Sign On Policies" [(isCollapsed)]="collapsed['two-factor']">
    <ng-container>
      <div *ngIf="profileLoading">
        <div class="spinner spinner-sm">
          <div class="lspinner"></div>
        </div>
        <div class="text-center">Sign On Policies is loading</div>
      </div>

      <div *ngIf="!profileLoading">
        <div class="row">
          <div class="col">
            <div class="form-group mb-4" *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">
              <button class="btn btn-default" *ngIf="!editTwoFactor" (click)="twoFactorClicked()">Edit</button>
              <button class="btn btn-success" *ngIf="editTwoFactor" (click)="updateTwoFactor()" [disabled]="!updateUserForm.valid">Save</button>
              <button class="btn btn-cancel" *ngIf="editTwoFactor" (click)="cancelTwoFactor()">Cancel</button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <div class="form-group">
              <label class="mb-2">Sign On Policies</label>
              <div *ngIf="editTwoFactor">
                <ngx-bootstrap-multiselect [ngModelOptions]="{standalone: true}" required [texts]="multiSelectSettingsTexts" [settings]="multiSelectSettings" name="signOnPolicies" [options]="signOnOptions" [(ngModel)]="signOnPolicies"></ngx-bootstrap-multiselect>
              </div>
              <div *ngIf="!editTwoFactor && user.factor">
                <span>
                  {{ selectedPolicies }}
                </span>
              </div>
            </div>

              <div class="mt-2" *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">
              <a *ngIf="!resettingFactor" class="text-primary" [routerLink]="[]" (click)="resetFactor()">Reset Two-Factor Authentication</a>
              <span *ngIf="resettingFactor"> Resetting ... Please wait</span>

            </div>

          </div>
        </div>
      </div>
    </ng-container>
  </re-collapsible-group>

  <re-collapsible-group header="{{adminAccess}}" *ngIf="!snfProduct.display" [(isCollapsed)]="collapsed['admin-access']">
    <ng-container>

      <div class="row">
        <div class="col-12">
          <div class="form-group mb-4" *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">
            <button class="btn btn-default" *ngIf="!editAccess" (click)="editAccessClicked()">Edit</button>
            <button class="btn btn-success" *ngIf="editAccess" [disabled]="!updateUserForm.valid" (click)="updateUserProfile()">Save</button>
            <button class="btn btn-cancel" *ngIf="editAccess" (click)="resetAccessFlags()">Cancel</button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <div class="form-group input-required">
            <label for="userType">IDM User Admin Access</label>
            <ng-template #statusTooltip>
              <div>
                <ul>
                  <li *ngIf="adminToolRoleDataContains('RU')">No Admin Rights</li>
                  <li *ngIf="adminToolRoleDataContains('LMA')"><span class="font-weight-bold">Location Admin - </span> All admin rights for single MatrixCare 360 location</li>
                  <li *ngIf="adminToolRoleDataContains('CLA')"><span class="font-weight-bold">Limited Admin - </span> Limited Admins can do password resets for any user across all locations</li>
                  <li *ngIf="adminToolRoleDataContains('UMA')"><span class="font-weight-bold">Corporate Admin - </span> All admin rights for all locations </li>
                  <li *ngIf="adminToolRoleDataContains('LLA')"><span class="font-weight-bold">Location Limited Admin - </span> Limited admin rights for single MatrixCare 360 location </li>
                </ul>
              </div>
            </ng-template>
            <span class="ml-2 text-primary fa fa-solid fa-circle-info" placement="end" [ngbTooltip]="statusTooltip" tooltipClass="mfa-tooltip"></span>

            <span [ngClass]="{'form-control': editAccess, 'form-control-plaintext': !editAccess}" *ngIf="!editAccess">{{userService.getUserAccesText(user.adminToolRole)}}</span>
            <select2 *ngIf="editAccess" [(ngModel)]="user.adminToolRole" [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="adminToolRole"
                     (onSelect)="userAccessTypeChanged()" [disabled]="isPhysicianNppaUser" [options]="adminToolRoleData"></select2>

            @if (user.federatedIdentity===false && user.adminToolRole=='UMA' && !updateUserForm.controls['email'].value){
            <small class="text-danger">Email address has not been entered and is recommended for admin users</small>
            }
          </div>
        </div>
        <!-- This section is added on update for token and skim mapping -->
        <div class="form-group input-required col-4 col-lg-4 col-xl-4 ml-2" [ngStyle]="{'margin-top':  '20px' }" *ngIf="customerFederationEnabled && scimEnabled && !isLocationAdmin">
          <div class="form-check">
            <input class="form-check-input" [(ngModel)]="user.tokenManagement" formControlName="tokenManagement" id="tokenManagement" type="checkbox" value="" [attr.disabled]="!editAccess || isPhysicianNppaUser ? true : null">
            <label class="form-check-label" for="access token management">Access Token Management</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" [(ngModel)]="user.scimMapping" formControlName="scimMapping" id="scimMapping" type="checkbox" value="" [attr.disabled]="!editAccess || isPhysicianNppaUser ? true : null">
            <label class="form-check-label" for="scim mapping">SCIM Mapping</label>
          </div>
        </div>
      </div>
    </ng-container>
  </re-collapsible-group>

  <!-- <re-collapsible-group header="{{adminAccess}}" *ngIf="snfProduct.display">

    <div class="row">
      <div class="col-12">
          <div class="form-group mb-4" *ngIf="!isSupportUser && !isCorporateLimitedAdmin">
              <button class="btn btn-default" *ngIf="!editUserAccess && !localAdminAndEditingSelf" (click)="editUserAccessClicked()" [disabled]="accessDisabledSL">Edit</button>
              <button class="btn btn-success" *ngIfs="editUserAccess" [disabled]="!updateUserForm.valid " (click)="updateUserProfile()">Save</button>
              <button class="btn btn-cancel" *ngIf="editUserAccess" (click)="resetUserAccessFlags()">Cancel</button>
          </div>
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        <div class="form-group input-required">
          <label for="userType">IDM User Admin Access</label>
          <ng-template #statusTooltip>
              <div>
                  <ul>
                      <li *ngIf="adminToolRoleDataContains('RU')">No Admin Rights</li>
                      <li *ngIf="adminToolRoleDataContains('LMA')"><span class="font-weight-bold">Single Location Admin - </span> All admin rights for single MatrixCare 360 location</li>
                      <li *ngIf="adminToolRoleDataContains('CLA')"><span class="font-weight-bold">Corporate Limited Admin - </span> Limited Admins can do password resets for any user across all locations</li>
                      <li *ngIf="adminToolRoleDataContains('UMA')"><span class="font-weight-bold">Corporate Full Admin - </span> All admin rights for all locations </li>
                  </ul>
              </div>
              </ng-template>
          <span class="ml-2 text-primary fa-solid fa-circle-info" placement="end" [ngbTooltip]="statusTooltip" tooltipClass="mfa-tooltip"></span>


          <span [ngClass]="{'form-control': editUserAccess, 'form-control-plaintext': !editUserAccess}" *ngIf="!editUserAccess">{{userService.getUserAccesText(user.adminToolRole)}}</span>
          <select2 *ngIf="editUserAccess" [(ngModel)]="user.adminToolRole" [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="adminToolRole"
                   (onSelect)="userAccessTypeChanged()" [options]="adminToolRoleData"></select2>
          </div>
        </div>

        <div class="form-group input-required col-4 col-lg-4 col-xl-4 ml-2 mt-4" *ngIf="customerFederationEnabled && scimEnabled && user.adminToolRole && user.adminToolRole !== 'LMA'">
            <div class="form-check">
                <input class="form-check-input" [(ngModel)]="user.tokenManagement" formControlName="tokenManagement" id="tokenManagement" type="checkbox" value="" [attr.disabled]="!editUserAccess ? true : null">
                <label class="form-check-label" for="access token management">Access Token Management</label>
            </div>
            <div class="form-check">
                <input class="form-check-input" [(ngModel)]="user.scimMapping" formControlName="scimMapping" id="scimMapping" type="checkbox" value="" [attr.disabled]="!editUserAccess ? true : null">
                <label class="form-check-label" for="scim mapping">SCIM Mapping</label>
            </div>
        </div>
    </div>
  </re-collapsible-group> -->

  <re-product-information [product]="snfProduct" [showLinks]="!localAdminAndEditingSelf">
    <ng-container re-pi-content>

      <div class="row">
        <div class="col-12">
          <div class="form-group mb-4" *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">
            <button class="btn btn-default" *ngIf="!editAccess && !localAdminAndEditingSelf" (click)="editAccessClicked()" [disabled]="accessDisabledSL">Edit</button>
            <button class="btn btn-success" *ngIf="editAccess" [disabled]="!updateUserForm.valid || !facilityRoleAssignmentForm.valid " (click)="updateUserProfile()">Save</button>
            <button class="btn btn-cancel" *ngIf="editAccess" (click)="resetAccessFlags()">Cancel</button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <div class="form-group input-required">
            <label for="userType">IDM User Admin Access</label>
            <ng-template #statusTooltip>
              <div>
                <ul>
                  <li *ngIf="adminToolRoleDataContains('RU')">No Admin Rights</li>
                  <li *ngIf="adminToolRoleDataContains('LMA')"><span class="font-weight-bold">Location Admin - </span> All admin rights for single MatrixCare 360 location</li>
                  <li *ngIf="adminToolRoleDataContains('CLA')"><span class="font-weight-bold">Limited Admin - </span> Limited Admins can do password resets for any user across all locations</li>
                  <li *ngIf="adminToolRoleDataContains('UMA')"><span class="font-weight-bold">Corporate Admin - </span> All admin rights for all locations </li>
                  <li *ngIf="adminToolRoleDataContains('LLA')"><span class="font-weight-bold">Location Limited Admin - </span> Limited admin rights for single MatrixCare 360 location </li>
                </ul>
              </div>
            </ng-template>
            <span class="ml-2 text-primary fa-solid fa-circle-info" placement="end" [ngbTooltip]="statusTooltip" tooltipClass="mfa-tooltip"></span>


            <span [ngClass]="{'form-control': editAccess, 'form-control-plaintext': !editAccess}" *ngIf="!editAccess">{{userService.getUserAccesText(user.adminToolRole)}}</span>
            <select2 *ngIf="editAccess" [(ngModel)]="user.adminToolRole" [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="adminToolRole"
                     (onSelect)="userAccessTypeChanged()" [disabled]="isPhysicianNppaUser" [options]="adminToolRoleData"></select2>
            @if (user.federatedIdentity===false && user.adminToolRole=='UMA' && !updateUserForm.controls['email'].value){
            <small class="text-danger">Email address has not been entered and is recommended for admin users</small>
            }
          </div>
        </div>
        <!-- This section is added on update for token and skim mapping -->
        <div class="form-group input-required col-4 col-lg-4 col-xl-4 ml-2 mt-4" *ngIf="customerFederationEnabled && scimEnabled && user.adminToolRole && user.adminToolRole !== 'LMA' && !isLocationAdmin">
          <div class="form-check">
            <input class="form-check-input" [(ngModel)]="user.tokenManagement" formControlName="tokenManagement" id="tokenManagement" type="checkbox" value="" [attr.disabled]="!editAccess || isPhysicianNppaUser ? true : null">
            <label class="form-check-label" for="access token management">Access Token Management</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" [(ngModel)]="user.scimMapping" formControlName="scimMapping" id="scimMapping" type="checkbox" value="" [attr.disabled]="!editAccess || isPhysicianNppaUser ? true : null">
            <label class="form-check-label" for="scim mapping">SCIM Mapping</label>
          </div>
        </div>
      </div>
      <div class="row">

        <div class="col-sm-6 col-lg-4">
          <div class="form-group">
            <label for="userType">User Type</label>
            <span [ngClass]="{'form-control-plaintext': !editAccess || userTypeReadOnlyForCorp}" *ngIf="!editAccess || userTypeReadOnlyForCorp">{{user.userType||'Not Selected'}}</span>
            <select2 *ngIf="editAccess && !userTypeReadOnlyForCorp" [(ngModel)]="user.userType" (onSelect)="userTypeChanged($event)" [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="userType"
                     [options]="userTypeData" [disabled]="isPhysicianNppaUser && user.role"></select2>
          </div>
        </div>

        <div class="col-sm-6 col-lg-4">
          <div class="form-group" [class.input-required]="editAccess && user.userType">
            <label for="corporationName">Corporation Name</label>
            <span [ngClass]="{'form-control': editAccess, 'form-control-plaintext': !editAccess}" *ngIf="!editAccess">{{user.corporationName||'Not Selected'}}</span>

            <select2 [(ngModel)]="user.corporationName" (onSelect)="corporationChanged($event)" *ngIf="editAccess" [settings]="corporationSettings" formControlName="corporationName" [ngClass]="{'form-control-plaintext': !editAccess}"
                     [options]="corporations"></select2>
            <span *ngIf="updateUserForm.controls['corporationName'].hasError('mcmdError')" class="text-danger mt-1 ml-2 mb-0">Please remove roles in {{ multicareMobile }} Access section below to save changes.</span>
          </div>
        </div>
        <div class="col-sm-6 col-lg-4" *ngIf="user.userType==careSettingName && !isPhysicianNppaUser">
          <div class="form-group" [class.input-required]=" editAccess && user.userType">
            <label for="careSettingName">Care Setting Name</label>

            <span [ngClass]="{'form-control': editAccess, 'form-control-plaintext': !editAccess}" *ngIf="!editAccess">{{user.careSettingName||'Not Selected'}}</span>

            <select2 [(ngModel)]="user.careSettingName" (onSelect)="careSettingChanged($event)" *ngIf="editAccess" [settings]="careSettingSettings" formControlName="careSettingName" [ngClass]="{'form-control-plaintext': !editAccess}"
                     [options]="careSettings"></select2>

          </div>
        </div>

      </div>
      <div class="row">


        <div class="col-sm-6 col-lg-4">
          <div class="form-group" [class.input-required]="editAccess && user.userType">
            <label for="role">Template</label>
            <span [ngClass]="{'form-control': editAccess, 'form-control-plaintext': !editAccess}" *ngIf="!editAccess">{{user.role||'Not Selected'}}</span>
            <select2 *ngIf="editAccess" (onSelect)="roleChanged($event)" [(ngModel)]="user.role" [settings]="roleSettings" formControlName="role" [ngClass]="{ 'form-control-plaintext': !editAccess}"
                     [options]="roles"></select2>
            <span *ngIf="editAccess" class="helpText"> (Select from dropdown or enter custom data)</span>

          </div>
        </div>
        <div class="col-sm-6 col-lg-4" *ngIf="user.userType==careSettingName && !isPhysicianNppaUser">
          <div class="form-group" [class.input-required]="isDisciplineRequired && !isCustomRole" *ngIf="isDisciplineRequired">
            <label for="primaryDiscipline">Primary Discipline</label>
            <span [ngClass]="{'form-control': editAccess, 'form-control-plaintext': !editAccess}" *ngIf="!editAccess">{{user.primaryDiscipline||'Not Selected'}}</span>
            <select2 *ngIf="editAccess" [(ngModel)]="user.primaryDiscipline" [settings]="disciplineSettings" formControlName="primaryDiscipline" [ngClass]="{ 'form-control-plaintext': !editAccess}"
                     [options]="disciplines"></select2>

            <small *ngIf="updateUserForm.controls['primaryDiscipline'].hasError('disciplineRequired') || updateUserForm.controls['role'].hasError('disciplineRequired') " class="text-danger">Primary discipline is a required field</small>
            <span *ngIf="editAccess" class="helpText"><br />(Select from dropdown or enter custom data)</span>


          </div>
        </div>

      </div>
      <div class="row" *ngIf="corporateLimited">
        <div class="form-group col-sm-6 col-lg-4">
          <legend class="col-form-label">Corporate Access</legend>
          <p style="text-align:right;" class="mb-2" *ngIf="editAccess"> Selected facilities: {{selectedFacilities?.length}}</p>
          <ngx-treeview [itemTemplate]="itemTemplate"
                        [config]="config"
                        [items]="regionsTree | ngxTreeViewLocal:'name':'checked':!editAccess"
                        (selectedChange)="onSelectedChange($event); selectedFacilities = $event;">
          </ngx-treeview>
        </div>
      </div>

      <div *ngIf="isFacilityRoleAssignmentFormLoaded && isPhysicianNppaUser && user.role">

        <form [formGroup]="facilityRoleAssignmentForm">
          <label for="facilitySearch"><b>Facility & Role Assignment</b></label>

          <p style="text-align:right;width: 50%" > Selected facilities: {{getCheckedCount()}}</p>
          <input
            id="facilitySearch"
            type="text"
            class="form-control mb-3"
            placeholder="Search by facility name"
            [formControl]="searchControl"
            style="width: 50%;"/>

          <div *ngIf="showSelectAll" class="d-flex align-items-center mb-2 facility-bulk-actions" [class.facility-list-scrolled]="facilityListScrolled" style="width: 50%;">
            <input type="checkbox" id="selectAllFacilities"
                   [checked]="selectAllChecked"
                   [attr.disabled]="!editAccess || allFacilitiesPreSelected ? true : null"
                   (change)="editAccess && onSelectAllChange($any($event.target).checked)" />
            <label for="selectAllFacilities" class="ml-2 mb-0 font-weight-bold">Select All</label>
            <div *ngIf="editAccess" class="facility-default-role">
              <label class="mb-0 font-weight-bold">Default Role</label>
              <div class="ml-2" style="min-width: 180px;">
                <select2 [(ngModel)]="defaultRole" [ngModelOptions]="{standalone: true}"
                         [options]="defaultRoleOptions"
                         [settings]="{ placeholder: 'Not Selected', width: '100%' }"
                         [disabled]="!selectAllChecked"
                         (ngModelChange)="onDefaultRoleChange($event)">
                </select2>
              </div>
            </div>
            <span *ngIf="!editAccess && areAllAccessibleChecked" class="ml-3 form-control-plaintext">All facilities selected</span>
          </div>

          <div formArrayName="facilities">
            <div (scroll)="onFacilityListScroll($event)" style="max-height: 400px; overflow-y: auto; overflow-x: hidden; width: 50%">
            <ng-container *ngFor="let facility of facilities.controls; let i = index">
              <div
                [formGroupName]="i"
                class="row align-items-center facility-role-row mb-1"
                *ngIf="facility.get('visible')?.value"> <!-- Only show rows where `visible` is true -->

                <div class="col-auto d-flex align-items-center facility-role-name" style="gap: 2px;">
                  <input
                    type="checkbox"
                    formControlName="checked" (change)="onFacilityRoleCheckedChange(i)"
                    [attr.disabled]="!editAccess || !facility.get('accessible')?.value || facilityRoleAssignmentForm.get('facilities').controls[i].get('checked')?.disabled ? true : null" />
                  <span class="form-control-plaintext"
                        [ngClass]="{'text-muted': !facility.get('accessible')?.value}">{{ facility.get('name')?.value }}</span>
                </div>

                <div class="col-sm-6 col-lg-3 facility-role-dropdown" [class.disabled]="!editAccess">
                  <select2
                    formControlName="role"
                    [options]="facilityRoles"
                    [settings]="{ placeholder: 'Not Selected', width: '100%' }"
                    [disabled]="!editAccess || !facility.get('accessible')?.value || !facilityRoleAssignmentForm.get('facilities').controls[i].get('checked').value || facilityRoleAssignmentForm.get('facilities').controls[i].get('originalRole')?.value === 'Physician'"
                    (onSelect)="onFacilityRoleAssignmentChange(i)">
                  </select2>
                  <div *ngIf="(facilityRoleAssignmentForm.get('facilities').controls[i].get('role').hasError('required') || !facilityRoleAssignmentForm.get('facilities').controls[i].get('role').value) && facilityRoleAssignmentForm.get('facilities').controls[i].get('checked').value" class="text-danger">
                    Role is required.
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          </div>
        </form>

      </div>


    </ng-container>
  </re-product-information>

  <re-collapsible-group header="{{multicareMobile}} Access" [(isCollapsed)]="collapsed['mc']" *ngIf="showMulticareSection && snfProduct.display">
    <ng-container>

      <div class="row">
        <div class="col-12">
          <div class="form-group mb-4" *ngIf="!isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">
            <button class="btn btn-default" *ngIf="!editAccessMatrixCare && !localAdminAndEditingSelf && !isSupportUser" (click)="editAccessMatrixCareClicked()">Edit</button>
            <button class="btn btn-success" *ngIf="editAccessMatrixCare && !isSupportUser" [disabled]="!updateUserForm.valid" (click)="updateUserProfile()">Save</button>
            <button class="btn btn-cancel" *ngIf="editAccessMatrixCare" (click)="resetAccessMatrixCareFlags()">Cancel</button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-6 col-lg-6 col-xl-6" *ngIf="multicareMobileEnabled">
            <label for="mcmdRole">MatrixCare Engage Mobile App Role</label>
            <br>
            <span [ngClass]="{'form-control': editAccessMatrixCare, 'form-control-plaintext': !editAccessMatrixCare}" *ngIf="!editAccessMatrixCare">{{ user.mcmdRole || 'Not Selected' }}</span>
            <select2 *ngIf="editAccessMatrixCare" [(ngModel)]="user.mcmdRole" [settings]="{placeholder: 'Not Selected',width:'50%'}" formControlName="mcmdRole" [ngClass]="{ 'form-control-plaintext': !editAccessMatrixCare}"
                      (onSelect)="mcmdRoleChanged()" [options]="mcmdRoleData"></select2>
        </div>
      </div>
      <div class="row" *ngIf="multicareEformsEnabled">
        <div class="form-group col-6 col-lg-6 col-xl-6">
            <label for="eFormsRole">MatrixCare Engage eForms Role</label>
            <br>
            <span [ngClass]="{'form-control': editAccessMatrixCare, 'form-control-plaintext': !editAccessMatrixCare}" *ngIf="!editAccessMatrixCare">{{ user.eFormsRole || 'Not Selected' }}</span>
            <select2 *ngIf="editAccessMatrixCare" [(ngModel)]="user.eFormsRole" [settings]="{placeholder: 'Not Selected',width:'50%'}" formControlName="eFormsRole" [ngClass]="{ 'form-control-plaintext': !editAccessMatrixCare}"
                      (onSelect)="eFormsRoleChanged()" [options]="eFormsRoleData"></select2>
        </div>
      </div>
      <div class="row" *ngIf="updateUserForm.controls['mcmdRole'].hasError('invalid') || updateUserForm.controls['eFormsRole'].hasError('invalid')">
        <div class="col-12">
          <p class="text-danger mt-1 ml-2 mb-0">Please select MatrixCare 360 Corporation.</p>
        </div>
      </div>
    </ng-container>
  </re-collapsible-group>

  <re-product-information [product]="slProduct" [showLinks]="!localAdminAndEditingSelf">
    <ng-container re-pi-content>
      <div class="row" *ngIf="!confirmedAccessSL">
        <div class="col-12">
          <div class="form-group mb-4" *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">
            <button class="btn btn-default" *ngIf="!editAccessSL && !localAdminAndEditingSelf" (click)="editSLAccessClicked()" [disabled]="accessDisabled">Edit</button>
            <button class="btn btn-success" *ngIf="editAccessSL" [disabled]="!updateUserForm.valid || !user.slProvisioned" data-toggle="modal" data-target="#slAccessModal" data-keyboard="true" data-backdrop="static">Save</button>
            <button class="btn btn-cancel" *ngIf="editAccessSL" (click)="resetAccessFlagsSL()">Cancel</button>
          </div>
          <div class="form-check">
            <input class="form-check-input" id="slProvisioned" formControlName="slProvisioned" type="checkbox"
                   [(ngModel)]="user.slProvisioned" value="" [attr.disabled]="editAccessSL ? null : true">
            <label class="form-check-label font-weight-bold" for="slProvisioned">Provide User Access</label>
          </div>
        </div>
      </div>


      <div class="modal fade" tabindex="-1" id="slAccessModal" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title"><i class="fa fa-warning neo-warning"></i>&nbsp; Access Warning</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <p class="font-weight-bold">This will give the user access to Senior Living</p>
              <p>Do you want to confirm access?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="saveSLAccessClicked()">Confirm Access</button>
              <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="resetAccessFlagsSL()">Cancel</button>
            </div>
          </div>

        </div>
      </div>

    </ng-container>


  </re-product-information>

  <re-product-information [product]="trueSenseProduct" [showLinks]="!localAdminAndEditingSelf">
    <ng-container re-pi-content>
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-4" *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">
            <button class="btn btn-default" *ngIf="!editAccessTrueSense && !localAdminAndEditingSelf" (click)="editTrueSenseAccessClicked()" [disabled]="accessDisabled">Edit</button>
            <button class="btn btn-success" *ngIf="editAccessTrueSense" [disabled]="!updateUserForm.valid" (click)="saveTrueSenseAccessClicked()">Save</button>
            <button class="btn btn-cancel" *ngIf="editAccessTrueSense" (click)="resetAccessFlagsTrueSense()">Cancel</button>
          </div>
          <div class="form-check">
            <input class="form-check-input" id="trueSenseProvisioned" formControlName="trueSenseProvisioned" type="checkbox"
                   [(ngModel)]="user.trueSenseProvisioned" value="" [attr.disabled]="editAccessTrueSense ? null : true">
            <label class="form-check-label font-weight-bold" for="trueSenseProvisioned">Provide User Access</label>
          </div>
        </div>
      </div>
    </ng-container>
  </re-product-information>

  <re-product-information [product]="pdProduct" [showLinks]="!localAdminAndEditingSelf">
    <ng-container re-pi-content>
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-4" *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">
            <button class="btn btn-default" *ngIf="!userPdOfficeData && !editPdOffice" (click)="editPdOfficeClicked()">Edit</button>
            <button class="btn btn-success" *ngIf="editPdOffice" [disabled]="!updateUserForm.valid" (click)="savePdOffice()">Save</button>
            <button class="btn btn-cancel" *ngIf="editPdOffice" (click)="cancelEditPdOfficeClicked()">Cancel</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <label for="office">Office</label>
            <span [ngClass]="{'form-control': editPdOffice, 'form-control-plaintext': !editPdOffice}" *ngIf="!editPdOffice">{{userPdOfficeData?.name||"Not Selected"}}</span>
            <select2 *ngIf="editPdOffice" [(ngModel)]="user.officeId" [settings]="{placeholder: 'Not Selected', width: '100%'}" formControlName="officeId"
                     [options]="pdOfficeData"></select2>
          </div>
        </div>
      </div>
    </ng-container>
  </re-product-information>

  <re-product-information [product]="lpcProduct" [showLinks]="!localAdminAndEditingSelf">
    <ng-container re-pi-content>
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-4" *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">
            <button class="btn btn-default" *ngIf="!editLpcRoles" (click)="editLpcRolesClicked()">Edit</button>
            <button class="btn btn-success" *ngIf="editLpcRoles"
                    [disabled]="!updateUserForm.valid || !user.lpcRoles || !user.lpcRoles.length>0" (click)="saveLpcRoles()">
              Save
            </button>
            <button class="btn btn-cancel" *ngIf="editLpcRoles" (click)="cancelEditLpcRolesClicked()">Cancel</button>
          </div>
        </div>
      </div>
      <div class="col-4" *ngIf="editLpcRoles; else lpcDisplayRolesColumn">
        <div class="form-group" [class.input-required]="editLpcRoles && user.lpcRoles">
          <label for="lpcRoles">Roles</label>
          <ngx-bootstrap-multiselect *ngIf="editLpcRoles" [options]="lpcRoleOptions" [texts]="multiSelectSettingsTexts"
                                     [settings]="multiSelectSettings" formControlName="lpcRoles"
                                     ngDefaultControl id="lpcRoles" [(ngModel)]="user.lpcRoles"
                                     [ngClass]="{ 'form-control-plaintext': !editLpcRoles}"></ngx-bootstrap-multiselect>
        </div>
      </div>
      <ng-template #lpcDisplayRolesColumn>
        <div class="col" *ngIf="!editLpcRoles">
          <div class="form-group">
            <label>Roles</label>
            <span class="form-control-plaintext" *ngIf="!user.lpcRoles || user.lpcRoles.length==0 ; else lpcDisplayRolesRow">Not Selected</span>
            <ng-template #lpcDisplayRolesRow>
              <div class="row">
                <div class="col-2" *ngFor="let role of user.lpcRoles">
                  <span class="form-control-plaintext">{{role}}</span>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </re-product-information>


  <re-product-information [product]="ppProduct" [showLinks]="!localAdminAndEditingSelf">
    <ng-container re-pi-content>
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-4" *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">
            <button class="btn btn-default" *ngIf="!editPPRoles" (click)="editPPRolesClicked()">Edit</button>
            <button class="btn btn-success" *ngIf="editPPRoles"
                    [disabled]="!updateUserForm.valid" (click)="savePPRoles()">
              Save
            </button>
            <button class="btn btn-cancel" *ngIf="editPPRoles" (click)="cancelEditPPRolesClicked()">Cancel</button>
          </div>
        </div>
      </div>
      <div class="col-4" *ngIf="editPPRoles; else ppDisplayRolesColumn">
        <div class="form-group" [class.input-required]="editPPRoles && user.paymentPortalRole">
          <label for="paymentPortalRole">Role</label>
          <select2 [(ngModel)]="user.paymentPortalRole" [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="paymentPortalRole"
                   id="paymentPortalRole" [options]="ppRoleData" (onSelect)="paymentPortalRoleChanged()"></select2>
          <p *ngIf="updateUserForm.controls['paymentPortalRole']?.hasError('invalid')" class="text-danger mt-1 ml-2 mb-0">Please select MatrixCare 360 Corporation.</p>
        </div>
      </div>
      <ng-template #ppDisplayRolesColumn>
        <div class="col" *ngIf="!editPPRoles">
          <div class="form-group">
            <label>Role</label>
            <span class="form-control-plaintext">{{userService.getPaymentPortalRolesText(user.paymentPortalRole)}}</span>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </re-product-information>

  <re-product-information [product]="rtoProduct" [showLinks]="!localAdminAndEditingSelf">
    <ng-container re-pi-content>
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-4" *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">
            <button class="btn btn-default" *ngIf="!editRTORoles" (click)="editRTORolesClicked()">Edit</button>
            <button class="btn btn-success" *ngIf="editRTORoles"
                    [disabled]="!updateUserForm.valid" (click)="saveRTORoles()">
              Save
            </button>
            <button class="btn btn-cancel" *ngIf="editRTORoles" (click)="cancelEditRTORolesClicked()">Cancel</button>
          </div>
        </div>
      </div>
      <div class="col-4" *ngIf="editRTORoles; else rtoDisplayRolesColumn">
        <div class="form-group" [class.input-required]="editRTORoles && user.rtoRole">
          <label for="rtoRole">Role</label>
          <select2 [(ngModel)]="user.rtoRole" [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="rtoRole"
                   id="rtoRole" [options]="rtoRoleData" (onSelect)="rtoRoleChanged()"></select2>
          <p *ngIf="updateUserForm.controls['rtoRole']?.hasError('invalid')" class="text-danger mt-1 ml-2 mb-0">Please select MatrixCare 360 Corporation.</p>
        </div>
      </div>
      <ng-template #rtoDisplayRolesColumn>
        <div class="col" *ngIf="!editRTORoles">
          <div class="form-group">
            <label>Role</label>
            <span class="form-control-plaintext">{{userService.getRTORolesText(user.rtoRole)}}</span>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </re-product-information>

  <re-product-information [product]="solutionsForBusinessProduct" [showLinks]="!localAdminAndEditingSelf">
    <ng-container re-pi-content>
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-4" *ngIf="!isSupportUser && !isCorporateLimitedAdmin && !isUserLocationLimitedAdmin">
            <button class="btn btn-default" *ngIf="!editSolutionsForBusiness" (click)="editSolutionsForBusinessClicked()">Edit</button>
            <button class="btn btn-success" *ngIf="editSolutionsForBusiness" [disabled]="!updateUserForm.valid" (click)="saveSolutionsForBusiness()">Save</button>
            <button class="btn btn-cancel" *ngIf="editSolutionsForBusiness" (click)="resetAccessFlagsSolutionsForBusiness()">Cancel</button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-group col-sm-6 col-lg-4" *ngIf="editSolutionsForBusiness">
            <label for="solutionsForBusinessModules">Modules</label>
            <ngx-bootstrap-multiselect
              [texts]="multiSelectSettingsTexts"
              [settings]="multiSelectSettings"
              formControlName="solutionsForBusinessModules"
              ngDefaultControl
              id="solutionsForBusinessModules"
              [options]="solutionsForBusinessModuleOptions"
              [(ngModel)]="user.solutionsForBusinessModules"
              (ngModelChange)="solutionsForBusinessModulesChanged()">
            </ngx-bootstrap-multiselect>
            <small class="text-muted">Select the modules this user can access. Note: User must have a valid MatrixCare 360 corporation to access {{solutionsForBusinessProductName}} Portal.</small>
            <p *ngIf="updateUserForm.controls['solutionsForBusinessModules']?.hasError('invalid')" class="text-danger mt-1 ml-2 mb-0">Please select MatrixCare 360 Corporation.</p>
          </div>
          <div *ngIf="!editSolutionsForBusiness">
            <strong>Modules:</strong>
            <span class="form-control-plaintext">{{getSelectedSolutionsForBusinessModules()}}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </re-product-information>

</form>
